import AddEditPanelContainer from "./../../../containers/add-edit-panel";
import AddEditPanel from "./add-edit-panel";
import { pickLists, unitTypes, service } from "./../data";

export default AddEditPanelContainer(AddEditPanel, {
    pickLists,
    unitTypes,
    service,
});
